<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="county">County</label>
                    <wj-combo-box
                        id="county"
                        [(ngModel)]="target.county"
                        name="county"
                        [itemsSource]="countyOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        required
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="equipmentClass">Equipment class</label>
                    <wj-combo-box
                        id="equipmentClass"
                        [(ngModel)]="target.equipmentClass"
                        name="equipmentClass"
                        [itemsSource]="equipmentClassOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        required
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="rank">Rank (1 = primary)</label>
                    <input id="rank" type="number" min="1" class="form-control" [(ngModel)]="target.rank" name="rank" required />
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group">
                    <label for="tireVendorId">Vendor</label>
                    <wj-combo-box
                        id="tireVendorId"
                        [(ngModel)]="target.tireVendorId"
                        name="tireVendorId"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        required
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="serviceAreaNotes">Service area notes</label>
            <textarea
                id="serviceAreaNotes"
                class="form-control"
                rows="2"
                [(ngModel)]="target.serviceAreaNotes"
                name="serviceAreaNotes"
            ></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
